import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './ForgotPasswordForm.scss';

import validateForgotPassword from './validateForgotPassword';
import {
    Form,
    Button,
    FormTextField,
    ErrorMessage
} from 'components/controls';
import {isNotFoundError} from '../../../sources/ApiError';


export default class ForgotPasswordForm extends Component {
    static propTypes = {
        forgotPassword: PropTypes.object,
        forgotPasswordProcessing: PropTypes.bool,
        forgotPasswordError: PropTypes.object,
        onForgotPassword: PropTypes.func.isRequired,
        onHideForgotPassword: PropTypes.func.isRequired
    };

    state = {
        email: ''
    };

    componentWillUnmount() {
        if (this.props.forgotPasswordError)
            this.props.onHideForgotPassword();
    }

    render() {
        const {forgotPasswordProcessing, forgotPasswordError, forgotPassword} = this.props;
        const notFoundError = forgotPasswordError && isNotFoundError(forgotPasswordError);

        if (forgotPassword)
            return this.renderSuccess();

        return (
            <Form className={styles.form}
                  fieldValues={this.state}
                  clientValidate={validateForgotPassword}
                  serverError={forgotPasswordError}
                  processing={forgotPasswordProcessing}
                  onFieldChange={::this.handleFieldChanged}
                  onSubmit={::this.handleSubmit}
                  ref='form'>

                <FormTextField fieldKey='email'
                               type='text'
                               label={loc('email-label')}
                               placeholder={loc('email-placeholder')}/>

                <ErrorMessage type='commonErrors'>
                    {notFoundError && loc('email-not-found')}
                </ErrorMessage>

                <Button type='submit'
                        label={loc('send-label')}
                        className={styles.submitButton}/>

            </Form>
        );
    }

    handleSubmit() {
        const {onForgotPassword} = this.props;
        const {
            email
        } = this.state;
        onForgotPassword(email);
    }

    handleFieldChanged(fieldKey, {target: {value}}) {
        this.setState({
            [fieldKey]: value
        });
    }

    renderSuccess() {
        return (
            <div className={styles.success}>
                <p> Please check your email and reset password.</p>

                <Button label='Ok'
                        className={styles.submitButton}
                        onClick={this.props.onHideForgotPassword}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/ForgotPassword/ForgotPasswordForm.js